var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('agreement-modal',{ref:"agreement"}),_vm._v(" "),_c('div',{staticClass:"links"}),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v("Copyright © 2021 成都启点科技有限公司")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cf3c9f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/GlobalFooter.vue
// module id = ReW4
// module chunks = 22